import { STEP_UP_REQUIRED_URL } from 'shared';
import { setSigningUrl } from '../../../flex-finalize/actions';
import { setApprovedApplication, setLenderName, setPersonalInfo, } from '../../actions';
import { getReceiptRoute } from './receiptRouting';
export const createStatusRouter = (history, dispatch, analytics, path) => {
    return (result) => {
        const { status, adsAcceptedOfferStatus } = result;
        const buildPath = (subPath) => {
            const base = path.endsWith('/') ? path : `${path}/`;
            return `${base}${subPath}`;
        };
        if (status === 'created') {
            history.push(buildPath('landing'));
        }
        else if (status === 'transaction_created') {
            analytics?.track('ApplicationApproved', {});
            dispatch(setLenderName(result.consumerCreditInstrument?.lenderName || ''));
            dispatch(setPersonalInfo({
                firstName: result.firstName,
                lastName: result.lastName,
            }));
            dispatch(setApprovedApplication(result.consumerCreditInstrument));
            dispatch(setSigningUrl(result.signingUrl));
            history.push(buildPath('approval'));
        }
        else if (status === 'pending' &&
            adsAcceptedOfferStatus === 'pending_step_up') {
            history.push(STEP_UP_REQUIRED_URL);
        }
        else if (status === 'pending') {
            history.push(buildPath('pending'));
        }
        else if (status === 'declined') {
            history.push(buildPath('declined'));
        }
        else if (status === 'transaction_signed') {
            const receiptRoute = getReceiptRoute(result.signingUrl || '');
            if (receiptRoute) {
                history.push(receiptRoute);
            }
            else {
                history.push(buildPath('error'));
            }
        }
    };
};
